import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import Select from 'react-select';
import { MdSearch } from 'react-icons/lib/md';
import { httpClient } from '../../../api/httpClient';
import { urlConsultarCedulaMotos } from '../api/urls';
import { urlListarParentescos } from '../../../constants/urls';

const SpinnerCircular = () => (
    <svg
        style={{
            width: '16px',
            height: '16px',
            animation: 'spinMotosConductor 0.75s linear infinite',
            display: 'inline-block',
            verticalAlign: 'middle'
        }}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle
            cx="12"
            cy="12"
            r="10"
            stroke="rgba(255, 255, 255, 0.3)"
            strokeWidth="3"
        />
        <path
            fill="#ffffff"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
    </svg>
);

const styles = {
    label: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000',
        margin: 0
    },
    customCheckbox: {
        width: '22px',
        height: '22px',
        border: '2px solid #001871',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: '#ffffff'
    },
    customCheckboxChecked: {
        width: '22px',
        height: '22px',
        border: '2px solid #001871',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: '#001871'
    }
};

const selectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 })
};

const OPCIONES_TIPO_DOC = [
    { value: '1', label: 'Cédula de Identidad' },
    { value: '3', label: 'Pasaporte' }
];

const OPCIONES_GENERO = [
    { value: '1', label: 'Masculino' },
    { value: '2', label: 'Femenino' }
];

const OPCIONES_ESTADO_CIVIL = [
    { value: '1', label: 'Soltero(a)' },
    { value: '2', label: 'Casado(a)' },
    { value: '4', label: 'Divorciado(a)' },
    { value: '3', label: 'Unión Libre' },
    { value: '5', label: 'Viudo(a)' }
];

/**
 * Card de Datos del Conductor para Motos (1 elemento por renglón).
 */
const DatosConductorMoto = ({
    mismosDatosAsegurado,
    onChangeMismosDatosAsegurado,
    datosConductor,
    onChangeCampoConductor,
    errores,
    checkDeclaracionConductor,
    onChangeCheckDeclaracion,
    textoDeclaracionConductor
}) => {
    const [consultandoCedula, setConsultandoCedula] = useState(false);
    const [mensajeDinardap, setMensajeDinardap] = useState(null);
    const [opcionesParentesco, setOpcionesParentesco] = useState([]);

    useEffect(() => {
        var cargarParentescos = async () => {
            try {
                var res = await httpClient.get(urlListarParentescos + '&traerParentescoTitular=false');
                var pars = (res && (res.parentesco || res.parentescos || res.data)) || [];
                if (Array.isArray(pars)) {
                    var opts = pars.filter(function(p) {
                        return p.parCodigo !== "" && p.parCodigo !== null && p.parCodigo !== undefined;
                    }).map(function(p) {
                        return {
                            value: String(p.parCodigo !== undefined ? p.parCodigo : p.id),
                            label: p.parNombre || p.name || p.label || ''
                        };
                    });
                    setOpcionesParentesco(opts);
                }
            } catch (e) {
                console.error('Error al cargar parentescos:', e);
            }
        };
        cargarParentescos();
    }, []);

    var c = datosConductor || {};
    var err = errores || {};

    var tipoDoc = c.tipoDocumento || { value: '1', label: 'Cédula de Identidad' };
    if (tipoDoc && tipoDoc.value === 'CEDULA') {
        tipoDoc = { value: '1', label: 'Cédula de Identidad' };
    } else if (tipoDoc && tipoDoc.value === 'PASAPORTE') {
        tipoDoc = { value: '3', label: 'Pasaporte' };
    }
    var identificacion = c.identificacion || '';
    var nombres = c.nombres || '';
    var fechaNacimiento = c.fechaNacimiento || '';
    var genero = c.genero || null;
    var parentesco = c.parentesco || null;
    var estadoCivil = c.estadoCivil || null;

    var handleConsultarCedula = async function(numIdent) {
        var doc = numIdent || identificacion;
        if (!doc || doc.length < 10) return;

        setConsultandoCedula(true);
        setMensajeDinardap(null);
        try {
            var res = await httpClient.get(urlConsultarCedulaMotos + doc);
            var dp = (res && res.datosPersona) || (res && (res.transaccion !== false || res.estadoTransaccion) ? res : null);
            
            if (dp && (dp.nombre || dp.nombres || dp.cedula || dp.primer_nombre || dp.nombre1)) {
                var nombreCompleto = dp.nombre || dp.nombres || ((dp.primer_nombre || dp.nombre1 || '') + ' ' + (dp.segundo_nombre || dp.nombre2 || '') + ' ' + (dp.primer_apellido || dp.apellido1 || '') + ' ' + (dp.segundo_apellido || dp.apellido2 || '')).trim();
                if (nombreCompleto && onChangeCampoConductor) {
                    onChangeCampoConductor('nombres', nombreCompleto.toUpperCase());
                }
                var fechaNac = dp.fecha_nacimiento || dp.fechaNacimiento || dp.fechaNac || '';
                if (fechaNac && onChangeCampoConductor) {
                    if (fechaNac.indexOf('/') !== -1) {
                        var parts = fechaNac.split('/');
                        if (parts.length === 3) {
                            fechaNac = parts[2] + '-' + (parts[1].length === 1 ? '0' + parts[1] : parts[1]) + '-' + (parts[0].length === 1 ? '0' + parts[0] : parts[0]);
                        }
                    }
                    onChangeCampoConductor('fechaNacimiento', fechaNac);
                }

                // Género
                var genRaw = dp.genero || dp.codigo_genero || '';
                if (genRaw && onChangeCampoConductor) {
                    var genStr = String(genRaw).toUpperCase();
                    var esMas = (genStr.indexOf('M') === 0 || genStr === '1');
                    onChangeCampoConductor('genero', { value: esMas ? '1' : '2', label: esMas ? 'Masculino' : 'Femenino' });
                }

                // Estado Civil
                var ecRaw = dp.estado_civil || dp.estadoCivil || dp.codigo_estado_civil || '';
                if (ecRaw && onChangeCampoConductor) {
                    var ecVal = String(ecRaw).toUpperCase();
                    var matchEc = OPCIONES_ESTADO_CIVIL.find(function(op) {
                        return op.value === ecVal || 
                            (ecVal === 'SOLTERO' && op.value === '1') ||
                            (ecVal === 'CASADO' && op.value === '2') ||
                            (ecVal === 'DIVORCIADO' && op.value === '4') ||
                            (ecVal === 'UNION LIBRE' && op.value === '3') ||
                            (ecVal === 'VIUDO' && op.value === '5') ||
                            op.label.toUpperCase().indexOf(ecVal) !== -1 || 
                            ecVal.indexOf(op.value) !== -1;
                    });
                    if (matchEc) {
                        onChangeCampoConductor('estadoCivil', matchEc);
                    }
                }

                setMensajeDinardap({ tipo: 'success', texto: 'Información recuperada automáticamente.' });
            } else {
                setMensajeDinardap({ tipo: 'info', texto: 'No se encontró información automática. Complete los datos manualmente.' });
            }
        } catch (error) {
            setMensajeDinardap({ tipo: 'warning', texto: 'No fue posible consultar el servicio de identificación. Complete manualmente.' });
        } finally {
            setConsultandoCedula(false);
        }
    };

    return (
        <Card className="shadow-sm mb-4">
            <CardBody style={{ padding: '2rem' }}>
                <h4 style={{ fontWeight: 'bold', color: '#000000', marginBottom: '1.5rem' }}>
                    Datos del Conductor
                </h4>

                {/* Pregunta: ¿El conductor es el mismo asegurado? */}
                <div 
                    className="d-flex align-items-center mb-3" 
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => {
                        if (onChangeMismosDatosAsegurado) {
                            onChangeMismosDatosAsegurado(!mismosDatosAsegurado);
                        }
                    }}
                >
                    <label 
                        htmlFor="checkMismosDatos" 
                        style={{ ...styles.label, cursor: 'pointer', margin: 0, marginRight: '16px', userSelect: 'none' }}
                    >
                        ¿El asegurado es el conductor?
                    </label>
                    <div 
                        id="checkMismosDatos"
                        style={mismosDatosAsegurado ? styles.customCheckboxChecked : styles.customCheckbox}
                        title="Marque si el asegurado es el conductor principal"
                    >
                        {mismosDatosAsegurado && (
                            <i className="fa fa-check text-white" style={{ fontSize: '13px' }} aria-hidden="true"></i>
                        )}
                    </div>
                </div>

                {/* Si no es el mismo, mostrar campos de conductor uno por renglón */}
                {!mismosDatosAsegurado && (
                    <div className="pt-3 border-top">
                        {mensajeDinardap && (
                            <div className={"alert alert-" + mensajeDinardap.tipo + " py-2 mb-3"}>
                                <i className="fa fa-info-circle mr-2"></i> {mensajeDinardap.texto}
                            </div>
                        )}

                        {/* 1. Tipo de Documento */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Tipo de documento(*)</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <Select 
                                    value={tipoDoc}
                                    onChange={(val) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('tipoDocumento', val);
                                    }}
                                    options={OPCIONES_TIPO_DOC}
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={selectStyles}
                                />
                            </Col>
                        </Row>

                        {/* 2. Cédula */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Cédula</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <div className="input-group">
                                    <input 
                                        type="text"
                                        className={"form-control" + (err.identificacion ? " is-invalid" : "")}
                                        placeholder="Ingrese la cédula del conductor"
                                        value={identificacion}
                                        onChange={(e) => {
                                            var val = e.target.value.replace(/[^0-9A-Za-z]/g, '');
                                            if (onChangeCampoConductor) onChangeCampoConductor('identificacion', val);
                                            if (val.length === 10 && (tipoDoc.value === '1' || tipoDoc.value === 'CEDULA')) {
                                                handleConsultarCedula(val);
                                            }
                                        }}
                                        maxLength={10}
                                    />
                                    <div className="input-group-append">
                                        <Button 
                                            color="secondary" 
                                            onClick={() => handleConsultarCedula()}
                                            disabled={consultandoCedula || !identificacion}
                                            title="Consultar cédula del conductor"
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '42px' }}
                                        >
                                            {consultandoCedula ? <SpinnerCircular /> : <MdSearch size={20} color="#ffffff" />}
                                        </Button>
                                    </div>
                                    <style>{`
                                        @keyframes spinMotosConductor {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}</style>
                                </div>
                                {err.identificacion && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Ingrese un número de cédula válido.
                                    </span>
                                )}
                            </Col>
                        </Row>

                        {/* 3. Nombre */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Nombre</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <input 
                                    type="text"
                                    className={"form-control" + (err.nombres ? " is-invalid" : "")}
                                    placeholder="Ingrese nombres completos del conductor"
                                    value={nombres}
                                    onChange={(e) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('nombres', e.target.value.toUpperCase());
                                    }}
                                />
                                {err.nombres && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor ingrese los nombres completos.
                                    </span>
                                )}
                            </Col>
                        </Row>

                        {/* 4. Fecha de Nacimiento */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Fecha de Nacimiento</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <input 
                                    type="date"
                                    className={"form-control" + (err.fechaNacimiento ? " is-invalid" : "")}
                                    value={fechaNacimiento}
                                    onChange={(e) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('fechaNacimiento', e.target.value);
                                    }}
                                />
                                {err.fechaNacimiento && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> {err.fechaNacimientoMsg || "Edad permitida: entre 18 y 70 años."}
                                    </span>
                                )}
                            </Col>
                        </Row>

                        {/* 5. Género */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Género</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <Select 
                                    value={genero}
                                    onChange={(val) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('genero', val);
                                    }}
                                    options={OPCIONES_GENERO}
                                    placeholder="Seleccione género..."
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={selectStyles}
                                />
                                {err.genero && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el género.
                                    </span>
                                )}
                            </Col>
                        </Row>

                        {/* 6. Parentesco con el asegurado */}
                        <Row className="mb-3 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Parentesco con el asegurado</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <Select 
                                    value={parentesco}
                                    onChange={(val) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('parentesco', val);
                                    }}
                                    options={opcionesParentesco}
                                    placeholder="Seleccione parentesco..."
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={selectStyles}
                                />
                                {err.parentesco && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el parentesco.
                                    </span>
                                )}
                            </Col>
                        </Row>

                        {/* 7. Estado Civil */}
                        <Row className="mb-2 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Estado Civil</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <Select 
                                    value={estadoCivil}
                                    onChange={(val) => {
                                        if (onChangeCampoConductor) onChangeCampoConductor('estadoCivil', val);
                                    }}
                                    options={OPCIONES_ESTADO_CIVIL}
                                    placeholder="Seleccione estado civil..."
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={selectStyles}
                                />
                                {err.estadoCivil && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el estado civil.
                                    </span>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                {/* Check obligatorio de Declaración del Conductor */}
                <div className="pt-3 border-top mt-3">
                    <div 
                        className="d-flex align-items-center" 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                        onClick={() => {
                            if (onChangeCheckDeclaracion) {
                                onChangeCheckDeclaracion(!checkDeclaracionConductor);
                            }
                        }}
                    >
                        <label 
                            htmlFor="checkDeclaracionConductor" 
                            style={{ 
                                ...styles.label, 
                                cursor: 'pointer', 
                                margin: 0, 
                                marginRight: '16px', 
                                userSelect: 'none' 
                            }}
                        >
                            {textoDeclaracionConductor || 'El conductor posee licencia tipo A vigente'}
                        </label>
                        <div 
                            id="checkDeclaracionConductor"
                            style={checkDeclaracionConductor ? styles.customCheckboxChecked : styles.customCheckbox}
                            title="Marque para aceptar la declaración obligatoria del conductor"
                        >
                            {checkDeclaracionConductor && (
                                <i className="fa fa-check text-white" style={{ fontSize: '13px' }} aria-hidden="true"></i>
                            )}
                        </div>
                    </div>
                    {err.declaracionConductor && (
                        <span className="text-danger d-block mt-2" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                            <i className="fa fa-exclamation-circle mr-1"></i> Debe aceptar la declaración del conductor para continuar.
                        </span>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default DatosConductorMoto;
